// Centralized site constants for Imperial Landscaping, TLH
export const SITE = {
  name: "Imperial Landscaping, TLH",
  phone: "850.661.2420",
  phoneTel: "+18506612420",
  email: "imperiallandscapingtlh@gmail.com",
  website: "imperiallandscapingtlh.com",
  city: "Tallahassee",
  state: "FL",
  region: "Tallahassee, Florida",
  tagline: "Lush lawns. Sun-kissed gardens. Built for Tallahassee.",
};

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_3c74e1a7-e674-4160-99cc-07fe3d921ca6/artifacts/rdqha159_1777811164229.png",
  portfolioAfter:
    "https://customer-assets.emergentagent.com/job_imperial-bloom/artifacts/i1olublx_AA8AC00D-0690-457D-9CE2-41B2C3A23DBF.jpg",
  portfolioBefore:
    "https://customer-assets.emergentagent.com/job_imperial-bloom/artifacts/yjt0cve9_B1E2E147-F16D-48CE-BAE4-B71B47236F84.jpg",
  transformBefore:
    "https://customer-assets.emergentagent.com/job_bb24e98e-17aa-45a4-a695-69a4492d1fc1/artifacts/ahx9ngc5_23509F3A-8794-4BF4-93EB-AAC67A6CDEF4~2.jpeg",
  transformAfter:
    "https://customer-assets.emergentagent.com/job_bb24e98e-17aa-45a4-a695-69a4492d1fc1/artifacts/90j3vh10_D065E89A-5E63-4C07-878C-C48C34D33FD0~2.jpeg",
  serviceLawn:
    "https://images.pexels.com/photos/6728925/pexels-photo-6728925.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  serviceDesign:
    "https://images.unsplash.com/photo-1649427909612-353b0042ab79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBsYXduJTIwY2FyZSUyMGxhbmRzY2FwaW5nfGVufDB8fHx8MTc3NzQwOTMyMnww&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  { id: "services", label: "Services" },
  { id: "work", label: "Our Work" },
  { id: "about", label: "About" },
  { id: "testimonials", label: "Reviews" },
  { id: "contact", label: "Contact" },
];

export const SERVICES = [
  {
    title: "Lawn Care & Mowing",
    blurb:
      "Weekly & bi-weekly mow, edge, trim, and blow. Healthy turf, crisp lines, no missed weeks.",
    icon: "Scissors",
    span: "md:col-span-7",
    accent: false,
  },
  {
    title: "Landscape Design",
    blurb:
      "Custom layouts that fit your home and the Florida sun — from front yard refresh to full property reimagining.",
    icon: "Sparkles",
    span: "md:col-span-5",
    accent: true,
  },
  {
    title: "Mulch & Flower Beds",
    blurb:
      "Fresh mulch, color-packed annuals, and clean-edged beds that pop from the curb.",
    icon: "Flower2",
    span: "md:col-span-5",
    accent: false,
  },
  {
    title: "Shrub & Tree Trimming",
    blurb:
      "Reshape overgrown shrubs, lift tree canopies, and bring back light & airflow.",
    icon: "TreeDeciduous",
    span: "md:col-span-7",
    accent: false,
  },
  {
    title: "Yard Cleanup & Hauling",
    blurb:
      "Leaves, limbs, debris — gone. We leave your property camera-ready.",
    icon: "Leaf",
    span: "md:col-span-6",
    accent: false,
  },
  {
    title: "Full-Service Maintenance",
    blurb:
      "One crew, one schedule, year-round. Predictable pricing and a yard that always looks loved.",
    icon: "CalendarCheck",
    span: "md:col-span-6",
    accent: false,
  },
];

export const TESTIMONIALS = [
  {
    name: "Marcus T.",
    location: "Killearn Estates, Tallahassee",
    quote:
      "They turned a jungle into a magazine cover. Crew showed up on time, three weeks straight. That's rare.",
    rating: 5,
  },
  {
    name: "Janelle R.",
    location: "Midtown, Tallahassee",
    quote:
      "Honest pricing, quick quote, and the flower beds out front make my neighbors stop walking. Hooked.",
    rating: 5,
  },
  {
    name: "The Alvarez Family",
    location: "Betton Hills",
    quote:
      "We tried two other companies before Imperial Landscaping, TLH. The difference is night & day. Friendly, fast, fair.",
    rating: 5,
  },
  {
    name: "Devon K.",
    location: "Southwood",
    quote:
      "Asked them to ‘just do something’ with our overgrown side yard — they came back with a plan and crushed it.",
    rating: 5,
  },
];

export const FAQS = [
  {
    q: "What areas do you serve?",
    a: "We're based in Tallahassee, FL and cover the surrounding Leon County neighborhoods — Killearn, Midtown, Betton Hills, Southwood, and beyond. Not sure if you're in our zone? Send us a quick message.",
  },
  {
    q: "How fast can I get a quote?",
    a: "Most quotes go out within 24 hours. For weekly maintenance we can usually start the same week — flower bed installs and bigger landscape projects depend on materials.",
  },
  {
    q: "Do you offer one-time cleanups or only recurring service?",
    a: "Both. One-time cleanups, seasonal refreshes, and weekly/bi-weekly maintenance plans — whatever fits your yard and budget.",
  },
  {
    q: "Are you insured?",
    a: "Yes. We carry full liability insurance and our crew is trained on every piece of equipment we run.",
  },
];
